import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MedicineBoxOutlined, FileProtectOutlined } from "@ant-design/icons";

const CLAIM_TYPES = [
  {
    value: "Hospitalized",
    title: "Hospitalized",
    description: "Claim for a hospital admission, invoice, or discharge.",
    icon: <MedicineBoxOutlined />,
  },
  {
    value: "Death",
    title: "Death",
    description: "Claim for a death benefit payout.",
    icon: <FileProtectOutlined />,
  },
];

export default function ClaimType(props: any) {
  const navigate = useNavigate();
  const { persist, setPersist } = props;
  const [type, setType] = useState<string | undefined>();

  function _onProceed() {
    setPersist({ ...persist, type });
    props.setTab(1);
  }

  return (
    <div className="w-full flex justify-center px-4">
      <div className="w-full max-w-md">
        <h2 className="font-semibold text-lg text-center text-neutral-900 mb-1">
          Select the type of claim
        </h2>
        <p className="text-sm text-neutral-500 text-center mb-6">
          Choose the option that matches what you're claiming for.
        </p>

        <div className="space-y-3">
          {CLAIM_TYPES.map((option) => {
            const selected = type === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => setType(option.value)}
                className={`w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-colors ${
                  selected
                    ? "border-[#06509E] bg-[#06509E]/5"
                    : "border-neutral-200 hover:border-neutral-300 hover:bg-neutral-50"
                }`}
              >
                <div
                  className={`h-11 w-11 rounded-full flex items-center justify-center shrink-0 text-lg ${
                    selected
                      ? "bg-[#06509E] text-white"
                      : "bg-neutral-100 text-neutral-500"
                  }`}
                >
                  {option.icon}
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-neutral-900">
                    {option.title}
                  </p>
                  <p className="text-sm text-neutral-500">
                    {option.description}
                  </p>
                </div>
                <div
                  className={`ml-auto h-5 w-5 rounded-full border-2 shrink-0 flex items-center justify-center ${
                    selected ? "border-[#06509E]" : "border-neutral-300"
                  }`}
                >
                  {selected && (
                    <div className="h-2.5 w-2.5 rounded-full bg-[#06509E]" />
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <div className="mt-8 space-y-3">
          <button
            type="button"
            onClick={_onProceed}
            disabled={!type}
            className="w-full h-12 rounded-lg bg-[#06509E] text-white font-medium hover:bg-[#053d7a] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Continue
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full h-12 rounded-lg border border-neutral-300 text-neutral-700 font-medium hover:bg-neutral-50 transition-colors"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
